var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrbital(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.39706 13.1916C10.712 13.1916 12.5885 11.315 12.5885 9.00008C12.5885 6.68519 10.712 4.80859 8.39706 4.80859C6.08216 4.80859 4.20557 6.68519 4.20557 9.00008C4.20557 11.315 6.08216 13.1916 8.39706 13.1916Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.9282 11.1915C14.9495 14.5319 11.8856 16.8298 8.39628 16.8298C4.07713 16.8298 0.566489 13.3191 0.566489 9C0.566489 4.68085 4.07713 1.17021 8.39628 1.17021C11.9069 1.17021 14.9495 3.48936 15.9282 6.82979C15.992 6.82979 16.0346 6.80851 16.0984 6.80851C15.1197 3.38298 11.992 1 8.39628 1C3.97075 1 0.375 4.57447 0.375 9C0.375 13.4255 3.97074 17 8.375 17C11.9495 17 15.0984 14.617 16.0771 11.1915C16.0346 11.2128 15.9707 11.1915 15.9282 11.1915Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.3116 10.8937C15.269 10.8937 14.418 10.0426 14.418 9.00006C14.418 7.95751 15.269 7.10645 16.3116 7.10645C17.3541 7.10645 18.2052 7.95751 18.2052 9.00006C18.2052 10.0426 17.3541 10.8937 16.3116 10.8937ZM16.3116 7.34049C15.3967 7.34049 14.652 8.08517 14.652 9.00006C14.652 9.91496 15.3967 10.6596 16.3116 10.6596C17.2265 10.6596 17.9712 9.91496 17.9712 9.00006C17.9924 8.08517 17.2265 7.34049 16.3116 7.34049Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbital);
export default __webpack_public_path__ + "static/media/Orbital.bf6c6fbf02af7f6aa2a3b0e36dede320.svg";
export { ForwardRef as ReactComponent };